module.exports = __webpack_public_path__ + "static/media/Artboard – 5.9e234d36.svg";